import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  Typography,
  CircularProgress,
  Breadcrumbs,
  Divider,
} from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { FormContrato } from './components/FormContrato';
import validationSchema from './formik/validationSchema';
import { useDispatch, useSelector } from 'react-redux';
import { useResponseHandler } from '../../../hooks/useResponseHandler';
// import { getContratoDetailStore, updateContratoStore } from './store/contratos.thunks';
// import { setContratoRedux } from './store/contratos.slice';
import contratoFormModel from './formik/contratoFormModel';
import { getContratoDetailStore, updateContratoStore } from 'store/contratos';
import { TypeContractOptions } from './data/data';

export const EditContrato = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { ResponseComponents, handleResponse } = useResponseHandler();
  const [loading, setLoading] = useState(true);

  const { contrato } = useSelector((state: any) => state.contratos);

  useEffect(() => {
    if (id) {
      getDetail(id);
    }
  }, [id]); // eslint-disable-line

  const getDetail = async (contratoId: string) => {
    setLoading(true);
    const response = await dispatch(getContratoDetailStore(contratoId));
    await handleResponse(response, 'Obtener contrato', false);
    setLoading(false);
  };

  const onSubmit = async (values: any, actions: any) => {
    if (!id) return;
    const { typeContract, ...dataToSend } = values;
    const response = await dispatch(updateContratoStore(id, dataToSend));

    await handleResponse(response, 'Actualizar contrato', true);

    if (!response.ok) {
      actions.setSubmitting(false);
      return false;
    }

    actions.setSubmitting(false);
  };

  const {
    formField: { name, typeContract, content },
  } = contratoFormModel;

  const matchedOption = contrato?.name
    ? TypeContractOptions.find((opt) => opt.label === contrato.name) || {
        label: 'Otro',
        value: 'otro',
      }
    : '';

  const initialValues = {
    [name.name]: contrato?.name || '',
    [typeContract.name]: matchedOption,
    [content.name]: contrato?.content || '',
  };

  return (
    <Box sx={{ width: '100%' }}>
      {ResponseComponents}

      <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>
        Editar Contrato
      </Typography>
      <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
        <Typography color="textPrimary" sx={{ fontWeight: 700 }}>
          Talento Humano
        </Typography>
        <Link color="inherit" to="/talento-humano/contratos" style={{ textDecoration: 'none' }}>
          Gestión de Contratos
        </Link>
        <Typography color="textPrimary">Editar Contrato</Typography>
      </Breadcrumbs>

      <Divider sx={{ marginBottom: 3 }} />

      <Card
        sx={{
          p: 3,
          borderRadius: 3,
          boxShadow: '0px 12px 24px -4px rgba(105, 108, 255, 0.15)',
          border: 'none',
        }}
      >
        <Typography variant="h6" sx={{ mb: 3 }}>
          Editar Información del Contrato
        </Typography>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema[0]}
            onSubmit={onSubmit}
            enableReinitialize
          >
            {({ isSubmitting, isValid, dirty }) => (
              <Form>
                <FormContrato />

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4, gap: 2 }}>
                  <Button
                    component={Link}
                    to="/talento-humano/contratos"
                    color="inherit"
                    sx={{ borderRadius: 2, textTransform: 'none' }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting || (!isValid && !dirty)}
                    sx={{
                      borderRadius: 2,
                      textTransform: 'none',
                      px: 3,
                      fontWeight: 600,
                    }}
                  >
                    Guardar Cambios
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
        )}
      </Card>
    </Box>
  );
};
